const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

class OrderInformationController {
    constructor(storeService) {
        this.storeService = storeService;
    }

    $onInit() {
        // hub & spoke orders does not have trading hours
        const orderDate = this.dateInfo && this.dateInfo.date
            ? new Date(this.dateInfo.date)
            : new Date();

        this.dayOfWeek = DAYS_OF_WEEK[orderDate.getDay()];
    }

    getFormattedAddress() {
        return this.addressInfo.street1 +
            (this.addressInfo.street2 ? `, ${this.addressInfo.street2}` : '') +
            (this.addressInfo.suburb && this.addressInfo.postcode
                ? `, ${this.addressInfo.suburb} ${this.addressInfo.postcode}`
                : '');
    }

    getStoreLinkParams() {
        if (!this.storeInfo.details) return {};

        return {
            store: this.storeService.getStoreUrl(this.storeInfo.details),
            storeDetails: this.storeInfo.details,
        };
    }
}

OrderInformationController.$inject = ['StoreService'];

const orderInformationComponentDefinition = {
    bindings: {
        orderInfo: '<',
        dateInfo: '<',
        addressInfo: '<',
        storeInfo: '<',
        isGuest: '<',
    },
    controller: OrderInformationController,
    template: require('./order-information.component.html').trim(),
};

module.exports = {
    OrderInformationController,
    orderInformationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/orderinformation/order-information.component.js